(() => {
  if (window.nuvanaCartLoaded) return;
  window.nuvanaCartLoaded = true;
  let busy = false;
  let opener;
  const root = () => document.querySelector('[data-nvc]');
  const dialog = () => root()?.querySelector('[data-nvc-dialog]');
  const open = trigger => {
    const modal = dialog();
    if (!modal || modal.open) return;
    opener = trigger || document.activeElement;
    modal.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const unlock = () => {
    document.documentElement.style.overflow = '';
    if (opener?.isConnected) opener.focus();
  };
  const close = () => { dialog()?.close(); unlock(); };
  const showError = message => {
    const error = root()?.querySelector('[data-nvc-error]');
    if (error) { error.textContent = message; error.hidden = false; }
  };
  const setBusy = value => {
    busy = value;
    root()?.querySelectorAll('.nvc-form').forEach(form => {
      form.setAttribute('aria-busy', String(value));
      form.querySelectorAll('button,input').forEach(control => { control.disabled = value || !!form.closest('[data-demo]'); });
    });
  };
  const render = html => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-nvc-content]');
    if (!next) throw new Error(root().dataset.error);
    root().querySelector('[data-nvc-content]').replaceWith(next);
    document.querySelectorAll('.lv-cart-count').forEach(el => el.remove());
    const count = Number(next.dataset.count);
    document.querySelectorAll('.lv-cart').forEach(link => {
      link.setAttribute('aria-label', `${root().dataset.cartLabel}, ${count}`);
      if (count) {
        const badge = document.createElement('span');
        badge.className = 'lv-cart-count'; badge.setAttribute('aria-hidden', 'true'); badge.textContent = count; link.append(badge);
      }
    });
  };
  const refresh = async () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', root().dataset.sectionId);
    const response = await fetch(url, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(root().dataset.error);
    const sections = await response.json();
    render(sections[root().dataset.sectionId]);
  };
  const request = async (url, body) => {
    const response = await fetch(url, {method:'POST', headers:{Accept:'application/json'}, body});
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : root().dataset.error);
    if (result.sections?.[root().dataset.sectionId]) render(result.sections[root().dataset.sectionId]);
    else await refresh();
    return result;
  };
  const update = async (key, quantity, focusQuantity = true) => {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    setBusy(true);
    const body = new FormData();
    body.set('id', key); body.set('quantity', quantity); body.set('sections', root().dataset.sectionId); body.set('sections_url', window.location.pathname + window.location.search);
    try {
      await request(root().dataset.changeUrl, body);
      if (focusQuantity) Array.from(root().querySelectorAll('[data-key]')).find(item => item.dataset.key === key)?.querySelector('input')?.focus();
    } catch (error) {
      try { await refresh(); } catch (_) {}
      showError(error.message || root().dataset.error);
    } finally { setBusy(false); }
  };
  document.addEventListener('click', event => {
    const cart = root();
    if (!cart) return;
    const trigger = event.target.closest('.lv-cart');
    if (trigger && dialog() && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault(); open(trigger);
      if (!cart.querySelector('[data-demo]') && !busy) refresh().catch(() => showError(cart.dataset.error));
      return;
    }
    if (event.target.closest('[data-nvc-close]')) { close(); return; }
    if (event.target === dialog()) {
      const rect = dialog().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      return;
    }
    const step = event.target.closest('[data-nvc-step]');
    const remove = event.target.closest('[data-nvc-remove]');
    if (!step && !remove) return;
    event.preventDefault();
    const item = (step || remove).closest('[data-key]');
    const value = remove ? 0 : Math.max(0, Number(item.querySelector('input').value) + Number(step.dataset.nvcStep));
    update(item.dataset.key, value, !remove);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-nvc-quantity]')) return;
    const quantity = Number(event.target.value);
    if (Number.isInteger(quantity) && quantity >= 0) update(event.target.closest('[data-key]').dataset.key, quantity);
    else refresh().catch(() => showError(root().dataset.error));
  });
  document.addEventListener('submit', async event => {
    if (!root()) return;
    if (event.target.matches('.nvc-form')) {
      if (busy || event.target.closest('[data-demo]')) event.preventDefault();
      return;
    }
    if (!event.target.matches('.lv-form') || !dialog()) return;
    event.preventDefault();
    if (busy) return;
    const form = event.target;
    const buttons = Array.from(document.querySelectorAll(`[form="${form.id}"], #${CSS.escape(form.id)} button[type="submit"]`));
    buttons.forEach(button => { button.disabled = true; });
    setBusy(true);
    const body = new FormData(form);
    body.set('sections', root().dataset.sectionId); body.set('sections_url', window.location.pathname + window.location.search);
    try {
      await request(root().dataset.addUrl, body);
      open(event.submitter);
    } catch (error) {
      open(event.submitter);
      showError(error.message || root().dataset.error);
    } finally {
      setBusy(false);
      buttons.forEach(button => { button.disabled = false; });
    }
  });
  const bindDialog = () => {
    const modal = dialog();
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = 'true';
    modal.addEventListener('close', unlock);
  };
  bindDialog();
  document.addEventListener('shopify:section:load', bindDialog);
  document.addEventListener('shopify:section:select', event => { if (event.target.querySelector('[data-nvc-dialog]')) open(); });
  document.addEventListener('shopify:section:deselect', event => { if (event.target.querySelector('[data-nvc-dialog]')) close(); });
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-nvc-dialog]')) unlock(); });
})();
